import React__default from 'react';

// Small helper component for conditionally wrapping other components
var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var wrapper = _ref.wrapper,
      children = _ref.children,
      condition = _ref.condition;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, condition ? wrapper(children) : children);
};

export { ConditionalWrapper };
